export function getEnv(name) {
    return process.env[name] || ''
  }
  